// ref: https://reacttricks.com/sharing-global-data-in-next-with-custom-app-and-usecontext-hook/

import { createContext, useContext } from 'react'

const BlockStateContext = createContext({});

// provides block settings to nested components

export const BlockStateProvider = ({ children, block }) => {

    return (
        <BlockStateContext.Provider value={block}>
            {children}
        </BlockStateContext.Provider>
    )
}

export const useBlockState = () => useContext(BlockStateContext)